import React from 'react';
import { LoaderCircle } from 'lucide-react';
import Spacing from '../Spacing';
import Card from '.';


export default function HaventVisitAndPreventativeDueCard({topLeftElement,bottomLeftElement,percentage,percentText,topRightElement,bottomRightElement,isLoading}) {

  return (
    <Card>
      <div className="highrisk_border_card">
        {isLoading ? (
          <div className="flex items-center loading" style={{ width: '100%', height: '100%', minHeight: '120px', justifyContent: 'center', background: 'var(--white)', borderRadius: '12px' }}>
            <span className="docpro_loading" style={{ position: 'inherit' }}>
              <LoaderCircle width={40} height={40} style={{color:"#369eff"}} />
            </span>
          </div>
        ) : (
          <>
            <div className="highrisk_card_top">
              <p className="docpro_fs_14 docpro_mb_0 docpro_mr_0">{topLeftElement}</p>
              <p className="docpro_fs_14 docpro_mb_0 docpro_mr_0">{topRightElement}</p>
            </div>
            <Spacing lg="4" sm="4" />
            <div className="highrisk_progress ">
              <div
                className="highrisk_progress_in"
                style={{ width: `${percentage}%` }}
              >
                {percentText}
              </div>
            </div>
            <div className="highrisk_progress_bottom mb-0">
              {bottomLeftElement}
              {bottomRightElement}
            </div>
          </>
        )}
      </div>
    </Card>
  );
}